import { Component, ElementRef, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { BehaviorSubject, combineLatest, Subject } from 'rxjs';
import { Required } from 'ZalamoLibrary/src/lib/core/decorators/Required';
import { ZalamoObject } from '@ui/orders/graphql';
import { map } from 'rxjs/operators';
import { AliveState } from 'ZalamoLibrary/src/lib/core/ActiveState';

@Component({
    selector: 'lib-tablo-single-photo-editor',
    templateUrl: './tablo-single-photo-editor.component.html',
    styleUrls: ['./tablo-single-photo-editor.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TabloSinglePhotoEditorComponent
  extends AliveState
  implements OnInit
{
  photos$ = new BehaviorSubject([]);
  tabloMember$ = new BehaviorSubject(null);
  @Input() @Required imagesContext: ZalamoObject;
  @Input() @Required contextId;
  containerRatio = 1;

  pickedPhotoId$ = new BehaviorSubject(null);

  set photos(photos) {
    this.photos$.next(photos);
  }

  set tabloMember(tabloMember: any) {
    if (tabloMember?.photo?.photoId) {
      this.pickedPhotoId$.next(tabloMember.photo.photoId);
    }
    this.tabloMember$.next(tabloMember);
  }
  currentValue;
  currentCropValue = null;
  saved = new Subject<{
    photoId: string;
    crop: [number, number, number, number];
  }>();

  photosToShow$ = combineLatest([this.photos$, this.pickedPhotoId$]).pipe(
    map(([photos, pickedPhotoId]) =>
      photos.map((v) => ({ ...v, picked: v.photo.photoId === pickedPhotoId })),
    ),
  );
  pickedPhoto$ = combineLatest([this.photos$, this.pickedPhotoId$]).pipe(
    map(([photos, pickedPhotoId]) =>
      photos.find((v) => v.photo.photoId === pickedPhotoId),
    ),
  );
  @Input() set(pickedPhotoId: string) {
    this.pickedPhotoId$.next(pickedPhotoId);
  }

  constructor(private ref: ElementRef<HTMLElement>) {
    super();
  }

  ngOnInit(): void {}

  save() {
    this.saved.next({
      crop: this.currentValue,
      photoId: this.pickedPhotoId$.value,
    });
  }
}
